import { useState } from "react";
import { BellRing } from "lucide-react";
import { api } from "../lib/api";
import { jobCategories } from "../data/content";

export default function JobAlertsForm({ compact = false, testId = "job-alerts" }) {
  const [form, setForm] = useState({ email: "", category: "All", location: "" });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const onChange = (event) => setForm({ ...form, [event.target.name]: event.target.value });

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      await api.jobAlert(form);
      setStatus("success");
      setForm({ ...form, email: "" });
    } catch (error) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className={`grid gap-4 border border-[#E2E8F0] bg-white p-5 ${compact ? "" : "md:p-6"}`} data-testid={`${testId}-form`}>
      <div className="flex items-start gap-3">
        <BellRing className="mt-1 h-5 w-5 text-[#0066FF]" />
        <div>
          <h3 className="font-heading text-xl font-black text-[#0A2540]" data-testid={`${testId}-title`}>Get job alerts by email</h3>
          <p className="mt-1 text-sm leading-6 text-[#64748B]" data-testid={`${testId}-description`}>Subscribe for matching role updates from TalentBridge.</p>
        </div>
      </div>
      {status === "success" && <p className="border border-emerald-200 bg-emerald-50 p-3 text-sm font-bold text-emerald-700" data-testid={`${testId}-success-message`}>Job alert subscription saved.</p>}
      {status === "error" && <p className="border border-red-200 bg-red-50 p-3 text-sm font-bold text-red-700" data-testid={`${testId}-error-message`}>Unable to subscribe right now. Please try again.</p>}
      <div className="grid gap-3 md:grid-cols-3">
        <label className="grid gap-2" data-testid={`${testId}-email-field`}>
          <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#475569]" data-testid={`${testId}-email-label`}>Email</span>
          <input name="email" type="email" required value={form.email} onChange={onChange} placeholder="you@email.com" className="min-h-11 border border-[#CBD5E1] px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0066FF]" data-testid={`${testId}-email-input`} />
        </label>
        <label className="grid gap-2" data-testid={`${testId}-category-field`}>
          <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#475569]" data-testid={`${testId}-category-label`}>Category</span>
          <select name="category" value={form.category} onChange={onChange} className="min-h-11 border border-[#CBD5E1] px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0066FF]" data-testid={`${testId}-category-input`}>
            <option value="All">All categories</option>
            {jobCategories.map((category) => <option key={category} value={category}>{category}</option>)}
          </select>
        </label>
        <label className="grid gap-2" data-testid={`${testId}-location-field`}>
          <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#475569]" data-testid={`${testId}-location-label`}>Location optional</span>
          <input name="location" value={form.location} onChange={onChange} placeholder="Calgary, Remote..." className="min-h-11 border border-[#CBD5E1] px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0066FF]" data-testid={`${testId}-location-input`} />
        </label>
      </div>
      <button type="submit" disabled={loading} className="inline-flex items-center justify-center gap-2 bg-[#0A2540] px-5 py-3 text-sm font-bold text-white hover:bg-[#051424] disabled:opacity-60" data-testid={`${testId}-submit-button`}>
        {loading ? "Subscribing..." : "Subscribe to job alerts"}
      </button>
    </form>
  );
}